import React from 'react';

import type { LogoProps } from '@atlaskit/logo';

import { useCommonContent } from '../../../use-content/index.tsx';

export const Header = (props: LogoProps): React.JSX.Element => {
	const { Logo } = useCommonContent();
	return <Logo size="small" appearance="brand" shouldUseNewLogoDesign {...props} />;
};
